



import BackButton from '@/components/common/back-button/BackButton.vue'
import CarouselSlide from '@/components/common/carousel-slide/CarouselSlide.vue'
import MarkedText from '@/components/common/marked-text/MarkedText.vue'
import Product from '@/components/products/Product'
import AttributeLabel
  from '@/components/products/product-details/attribute-label/AttributeLabel.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    BackButton,
    CarouselSlide,
    AttributeLabel,
    MarkedText
  }
})
export default class ProductDetails extends Vue {

  @Prop({ required: true }) product!: Product

  get customProperties() {
    return Object.entries(this.product.details).sort(([prevKey], [currKey]) => prevKey > currKey ? 1 : -1)
  }

}
